// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"CustomLightSelectInput_selectWrapper__2K9MP","selectButton":"CustomLightSelectInput_selectButton__n3om2","selectPopup":"CustomLightSelectInput_selectPopup__33EMf"};